import { render, staticRenderFns } from "./WebpartSampleView.vue?vue&type=template&id=d78071b4"
import script from "./WebpartSampleView.vue?vue&type=script&lang=ts"
export * from "./WebpartSampleView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports